module.exports = __webpack_public_path__ + "header-profile-skin-3.bf471ec3d4085883e061.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/assets/styles/patterns/header-profile-skin-3.png
// module id = ../../../../../src/assets/styles/patterns/header-profile-skin-3.png
// module chunks = styles